<template>
  <v-container fill-height fluid class="pt-0 pb-0">
    <v-row class="chat-container">
      <v-col cols="3">
        <v-row class="fill-height chat-row">
          <v-col cols="12" class="mh100">
            <unread-chats2></unread-chats2>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="5" class="fill-height pl-0 pr-0">
        <v-col cols="12" class="mh80 pa-0" style="margin-bottom: 12px;">
          <chat-messages v-if="activeChatAccountName"></chat-messages>
        </v-col>
        <v-col cols="12" class="mh20 pa-0">
          <actions-info v-if="activeChatAccountName"></actions-info>
        </v-col>
      </v-col>
      <v-col cols="4" class="fill-height">
        <template v-if="activeChatAccountName">
          <v-col cols="12" class="mh80 pa-0" style="margin-bottom: 12px;">
            <table-history ref="tableHistory" v-if="gameType(activeChatAccountName) !== 'ofc'" :name="activeChatAccountName"></table-history>
            <ofc-history ref="ofcHistory" v-if="gameType(activeChatAccountName) === 'ofc'" :name="activeChatAccountName"></ofc-history>
          </v-col>
          <v-col cols="12" class="mh20 pa-0">
            <v-row class="fill-height mt-0">
              <v-col :cols="isChatbotManager ? 6 : 12" class="fill-height py-0">
                <chat-suggestions></chat-suggestions>
              </v-col>
              <v-col cols="6" class="fill-height pl-0 py-0" v-if="isChatbotManager">
                <chatbot-suggestions></chatbot-suggestions>
              </v-col>
            </v-row>
          </v-col>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import UnreadChats2 from './UnreadChats2.vue';
import ChatMessages from './ChatMessages.vue';
import TableHistory from './TableHistory.vue';
import OfcHistory from './OfcHistory.vue';
import ActionsInfo from "../ActionsInfo";
import ChatSuggestions from "./ChatSuggestions";
import ChatbotSuggestions from "./ChatbotSuggestions";

export default {
  components: {
    ChatSuggestions,
    ChatbotSuggestions,
    ActionsInfo,
    'unread-chats2': UnreadChats2,
    'chat-messages': ChatMessages,
    'table-history': TableHistory,
    'ofc-history': OfcHistory,
  },
  computed: {
    ...mapGetters([
      'activeChatAccountName',
      'gameType',
      'isChatbotManager',
    ]),
    ...mapState([
      'testPreview',
    ]),
  },
  data() {
    return {
      text: ''
    };
  },
  methods: {
  }
}
</script>

<style scoped>
/* .row {
  height: 100% !important;
  max-height: 100% !important;
} */
.container {
  height: 100%;
  max-height: 100%;
}

.chat-container {
  height: calc(100vh - 48px) !important;
  max-height: calc(100vh - 48px) !important;
  /*overflow: hidden;*/
}

.chat-container > div {
  height: 100%;
}

.chat-row {
  margin: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

.chat-row > div {
  padding: 0;
  flex: 1 1 auto;
}

.mh10 {
  height: 10% !important;
  max-height: 10% !important;
}
.mh15 {
  height: 15% !important;
  max-height: 15% !important;
}
.mh20 {
  height: 20% !important;
  max-height: 20% !important;
}
.mh30 {
  height: 30% !important;
  max-height: 30% !important;
}
.mh40 {
  height: 40% !important;
  max-height: 40% !important;
}
.mh50 {
  height: 50% !important;
  max-height: 50% !important;
}
.mh60 {
  height: 60% !important;
  max-height: 60% !important;
}
.mh70 {
  height: 70% !important;
  max-height: 70% !important;
}
.mh80 {
  height: 80% !important;
  max-height: 80% !important;
}
.mh85 {
  height: 85% !important;
  max-height: 85% !important;
}
.mh90 {
  height: 90% !important;
  max-height: 90% !important;
}
.mh100 {
  height: 100% !important;
  max-height: 100% !important;
}
</style>
